import React, { useEffect, useState } from 'react';
import { Modal, Button, Row, Col } from 'antd';
import IssueApi from '@/fetch/bussiness/issue';
import { RootState } from '@/index';
import { useSelector } from 'react-redux';
import { HttpStatusCode } from '@/fetch/core/constant';
import { showMsg } from '@/utils/util';
import { IssueStatus } from '@/utils/constant';
interface Props {
  open: boolean;
  setOpen: AnyFunc;
  issueNumber: string;
  type: 'HOLD' | 'CANCEL_HOLD';
}
const fetchApi = new IssueApi();
const OnHoldIssueModal = (props: Props) => {
  const { open, setOpen, type, issueNumber } = props;
  const { issueList } = useSelector((state: RootState) => state.workOrder);

  const confirmOnHold = async () => {
    try {
      const res = await fetchApi.holdIssue({
        issueNumber: issueNumber,
      });
      if (res.code === HttpStatusCode.Success) {
        showMsg({
          msg: '挂单成功',
          type: 'success',
        });
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setOpen(false);
    }
  };
  const confirmCancelHold = async () => {
    try {
      const res = await fetchApi.cancelHoldIssue({
        issueNumber: issueNumber,
      });
      if (res.code === HttpStatusCode.Success) {
        showMsg({
          msg: '取消挂单成功',
          type: 'success',
        });
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setOpen(false);
    }
  };
  const renderContent = (type: string) => {
    if (!Array.isArray(issueList)) {
      return <></>;
    }
    switch (type) {
      case 'HOLD':
        return issueList.length > 1 &&
          issueList.find(
            (issue: any) => issue.issueStatus === IssueStatus.ON_HOLD,
          ) ? (
          <>
            <Row justify={'center'} align={'middle'}>
              <Col>
                <img
                  src={require('@/assets/img/views/instruct/warning_icon.png')}
                  style={{ marginRight: '8px' }}
                ></img>
              </Col>
              <Col>
                当前座席有挂起工单，挂起当前工单后，原挂起工单将被受理，是否确认挂单?
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row justify={'center'} align={'middle'}>
              <Col>
                <img
                  src={require('@/assets/img/views/instruct/warning_icon.png')}
                  style={{ marginRight: '8px' }}
                ></img>
              </Col>
              <Col>您是否确认挂单？</Col>
            </Row>
          </>
        );

      case 'CANCEL_HOLD':
        return issueList.length > 1 &&
          issueList.find(
            (issue: any) => issue.issueStatus === IssueStatus.PROCESS,
          ) ? (
          <>
            <Row justify={'center'} align={'middle'}>
              <Col>
                <img
                  src={require('@/assets/img/views/instruct/warning_icon.png')}
                  style={{ marginRight: '8px' }}
                ></img>
              </Col>
              <Col>
                当前座席有受理中工单，受理当前工单后，原受理中工单将被挂起，是否取消挂起当前工单？
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row justify={'center'} align={'middle'}>
              <Col>
                <img
                  src={require('@/assets/img/views/instruct/warning_icon.png')}
                  style={{ marginRight: '8px' }}
                ></img>
              </Col>
              <Col>您是否取消挂单？</Col>
            </Row>
          </>
        );
      default:
        return <></>;
    }
  };
  return (
    <>
      <Modal
        width={432}
        styles={{
          body: {
            height: '136px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
        }}
        open={open}
        onCancel={() => setOpen(false)}
        centered
        destroyOnClose
        footer={
          <>
            <div className='footer'>
              <div className='operate'>
                <Button
                  onClick={() => {
                    setOpen(false);
                  }}
                  style={{
                    marginRight: '12px',
                  }}
                >
                  取消
                </Button>
                <Button
                  type={'primary'}
                  onClick={() => {
                    if (type === 'HOLD') {
                      confirmOnHold();
                    } else {
                      confirmCancelHold();
                    }
                  }}
                >
                  确定
                </Button>
              </div>
            </div>
          </>
        }
      >
        {renderContent(type)}
      </Modal>
    </>
  );
};
export default React.memo(OnHoldIssueModal);
